import { CertificateDetailsInfoLoader } from '../loaders/CertificateDetailsInfoLoader';
import { CertificateStudentsLoader } from '../loaders/CertificateStudentsLoader';
import { CertificatesStudentsContent } from './CertificatesStudentsContent';

export function CertificatesStudents() {
  return (
    <CertificateDetailsInfoLoader>
      <CertificateStudentsLoader
        defaultQuery={{ page: 1, items_per_page: 10 }}
        fetchImmediately
      >
        <CertificatesStudentsContent />
      </CertificateStudentsLoader>
    </CertificateDetailsInfoLoader>
  );
}
